import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import ChartEditMetaView from "../../meta";
import DRGList from "./report";
import templates from "../../../../utils/templates";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: templates.find("chart_reviews", "chart_drg_list"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  regions() {
    return {
      meta: ".chart-review-meta",
      report: ".drg-list",
    };
  }

  initialize() {
    // localize chart model passed in via options
    this.chartModel = this.options.data.chartModel || null;

    this.listenTo(channel, "tab-activated", this._onActivate);
  }

  onBeforeShow() {
    this.meta.show(
      new ChartEditMetaView({
        model: this.chartModel,
        memberCategories: this.model.get("memberCategories"),
      })
    );
  }

  _onActivate(tab) {
    if ("tab-drg-file-history" === tab) {
      // pass a route config object
      this.report.show(
        new DRGList({
          routeConfig: {
            chartId: this.model.getChartReviewId(),
            drgId: this.model.getId(),
          },
        })
      );
    }
  }
}

export { View as default };
